<template>
    <div class="main sm:container mx-auto">
        <transition>
            <section>
                <router-view v-if="hasUserFetched"></router-view>
            </section>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { mountKareScript, removeKare } from '@/helpers/KareScriptHelpers';

export default {
    name: 'Account',
    mounted() {
        this.$store.dispatch('account/fetchUserData', true).then(() => {
            this.$store.dispatch('subscription/fetchAllSubscriptions', true);
        });
        this.enableKareWidget && mountKareScript(document);
    },
    computed: {
        ...mapGetters({
            enableKareWidget: 'localisation/enableKareWidget',
        }),
        hasUserFetched() {
            return this.$store.getters['account/getUserId'] !== null;
        },
    },
    beforeDestroy() {
        this.enableKareWidget && removeKare(document);
    },
};
</script>
